export const AdminConfig = {
    url: "https://quiz.apidata.app",
    project: "pl-app-test",
  };
  